import * as NS from './namespace';
import { SidebarItem, SidebarComponentItem, SidebarHeaderItem } from 'vue-sidebar-menu';

const getters: NS.ISidebarGetters = {
    getIsOpen(state: NS.ISidebarState): boolean {
        return state.isOpen;
    },
    getMenu(state: NS.ISidebarState): Array<SidebarItem | SidebarComponentItem | SidebarHeaderItem> {
        return state.menu;
    },
    getAdminMenu(state: NS.ISidebarState): Array<SidebarItem | SidebarComponentItem | SidebarHeaderItem> {
        return state.adminMenu;
    },
    getWidth(state: NS.ISidebarState): string | undefined {
        return state.width;
    },
    getWidthCollapsed(state: NS.ISidebarState): string | undefined {
        return state.widthCollapsed;
    },
}

/**
 * Реализация геттеров модуля сайдбара
 */
export default getters;